var map = {
	"./csharp.js": "INcn",
	"./golang.js": "y0aS",
	"./html.js": "5KyA",
	"./java.js": "zJn2",
	"./nodejs.js": "qxtL",
	"./php.js": "252X",
	"./python.js": "bTzu",
	"./shell.js": "bfXa"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0iHJ";


//////////////////
// WEBPACK FOOTER
// ./src/utils/codeWs/spot ^\.\/.*\.js$
// module id = 0iHJ
// module chunks = 3